import script from "./MarkdownPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownPreview.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownPreview.vue?vue&type=style&index=0&id=6ca3322f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca3322f"]])

export default __exports__